export default __webpack_public_path__ + "static/media/BarlowSemiCondensed-Medium.98a7f00b.ttf";